import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import { Divider, IconButton, Typography } from '@mui/material';
import { printVariable } from '@util/helper';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { useMediaQuery, useTheme } from "@mui/material";
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import useAlert from "@hooks/useAlert"

const TeacherImg = ({dialogHandler, imgUrl, callback}) =>  {
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const schola = useSelector(state => state.scholaReducer)
  const [file, set_file] = React.useState(null)
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const {alert, renderAlert} = useAlert()

  const handleClose = (event, reason)=> {
    if(reason && reason === "backdropClick") {
      return
    }
    else {
      if(callback) {
        callback()
      }
      set_file(null)
      dialogHandler[1](false)
    }
  }

  return (
    <Fragment>
      <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth='lg' fullWidth>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            {schola.name} 
          </Typography>
        
          <Typography variant='body' align='center'>강좌 소개 파일</Typography>
          <Divider></Divider>
        </DialogTitle>
        <DialogContent>
          {
            imgUrl ? (
              <div style={{width:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                <img src={imgUrl} />
              </div>
            ) : (
              <div>
                <Typography>이미지를 찾을 수 없습니다.</Typography>
              </div>
            )
          }
          

        </DialogContent>
        <DialogActions style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
          <Button onClick={handleClose}>닫기</Button>
        </DialogActions>
      </Dialog>
      {renderIndicator()}
      {renderAlert()}
    </Fragment>
		
	)
}

export default TeacherImg
